import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Tree } from "antd";
import UserTypes from "components/auth/user-types";
import { closeCustomModal, openCustomModal } from "components/custom/modals";
import {
    selectFolder,
    getFolders,
    getFilesByFolderId,
    createFolder,
    updateFolderById,
    deleteFolderById
} from "api/menu/file-manager/actions";

const { DirectoryTree } = Tree;
const ModalCreateFolder = React.lazy(() =>
    import("components/menu/file-manager/modal-create-folder"));

// https://ant.design/components/tree/
class FoldersMenu extends React.Component {
    constructor(props) {
        super(props);

        this.structureFolders = this.structureFolders.bind(this);
        this.loop = this.loop.bind(this);
        this.modalCreateFolder = this.modalCreateFolder.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

        this.state = {
            expandedKeys: []
        };

        this.props.getFolders();
    }

    onSelect = (selectedKeys) => {
        if (selectedKeys.length) {
            const folderId = selectedKeys[selectedKeys.length - 1];
            this.props.selectFolder(folderId);
            this.props.getFilesByFolderId(folderId);
        }
    };

    onExpand = (expandedKeys) => {
        this.setState({
            expandedKeys
        });
    };

    structureFolders = (parentId = 0) => {
        const {
            folders,
            jobFilter
        } = this.props;
        const subMenuItem = folders
            .filter(item => item.parentId === parentId)
            .filter(item => {
                if (jobFilter === "") {
                    return true;
                }
                if (parentId === 0) {
                    return true;
                }
                return item.fullName
                    .toLowerCase()
                    .includes(jobFilter.toLowerCase());
            });

        return subMenuItem.map(item => ({
            key: item.folderId.toString(),
            title: item.fullName,
            children: this.structureFolders(item.folderId)
        }));
    };

    loop = data => {
        const { jobFilter } = this.props;
        return data.map(item => {
            const index = item.title.indexOf(jobFilter);
            const beforeStr = item.title.substr(0, index);
            const afterStr = item.title.substr(index + jobFilter.length);
            const title =
                index > -1 ? (
                    <span>
                        {beforeStr}
                        <span className="text-danger">{jobFilter}</span>
                        {afterStr}
                    </span>
                ) : (
                    <span>{item.title}</span>
                );
            if (item.children && item.children.length) {
                return {
                    title,
                    key: item.key,
                    children: this.loop(item.children)
                };
            }

            return {
                title,
                key: item.key,
            };
        });
    };

    modalCreateFolder = (rename = false) => {
        const {
            selectedFolder,
            folders
        } = this.props;

        let folder = false;
        if (rename) {
            folder = folders
                .find(item => parseInt(item.folderId, 10) === parseInt(selectedFolder, 10));
        }

        const modalObj = {
            header: `${rename ? "Rename" : "Create"} folder`,
            modalSettings: {
                size: "sm",
            },
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ModalCreateFolder
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSave={folderName => {
                            if (rename && folder) {
                                this.props.updateFolderById(selectedFolder, {
                                    folderId: selectedFolder,
                                    parentId: folder.parentId,
                                    fullName: folderName
                                });
                            } else {
                                this.props.createFolder(folderName, selectedFolder || 0);
                            }
                            this.props.closeCustomModal(modalObj);
                        }}
                        folderName={rename ? folder.fullName : false}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleDelete = () => {
        const { selectedFolder } = this.props;
        if (!selectedFolder) {
            return false;
        }
        this.props.deleteFolderById(selectedFolder);
    };

    render() {
        const {
            userRole,
            selectedFolder
        } = this.props;
        const { expandedKeys } = this.state;
        const treeData = this.structureFolders(userRole.indexOf(UserTypes.admin) > -1 ? 0 : 1);

        const isEditable = userRole.indexOf(UserTypes.admin) > -1 ||
            userRole.indexOf(UserTypes.accountManager) > -1;

        return (
            <div className="position-relative file-manager-menu">
                <div className="border-bottom p-2 file-manager-title bg-info">
                    <h4 className="p-0 m-0 text-light">Folders</h4>
                </div>

                <div className="file-manager-content">
                    {!isEditable ||
                        <div className="clearfix border-bottom">
                            <button
                                className="btn btn-primary btn-sm rounded-0 mr-2"
                                onClick={() => this.modalCreateFolder()}
                            >
                                Create
                            </button>
                            <button
                                className="btn btn-warning btn-sm rounded-0 mr-2"
                                onClick={() => this.modalCreateFolder(true)}
                                disabled={!selectedFolder}
                            >
                                Rename
                            </button>
                            <button
                                className="btn btn-danger btn-sm rounded-0 mr-2"
                                onClick={this.handleDelete}
                                disabled={!selectedFolder}
                            >
                                Delete
                            </button>
                        </div>
                    }

                    {treeData.length ?
                        <DirectoryTree
                            autoExpandParent={true}
                            defaultExpandAll
                            onExpand={this.onExpand}
                            onSelect={this.onSelect}
                            // treeData={this.loop(treeData)}
                            treeData={treeData}
                            expandedKeys={expandedKeys}
                        />
                    : null}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userRole: state.auth.user.role,
    selectedFolder: state.fileManager.selectedFolder,
    folders: state.fileManager.folders,
    jobFilter: state.fileManager.jobFilter,
});

const mapStateToDispatch = dispatch => ({
    selectFolder: bindActionCreators(selectFolder, dispatch),
    getFolders: bindActionCreators(getFolders, dispatch),
    getFilesByFolderId: bindActionCreators(getFilesByFolderId, dispatch),
    createFolder: bindActionCreators(createFolder, dispatch),
    updateFolderById: bindActionCreators(updateFolderById, dispatch),
    deleteFolderById: bindActionCreators(deleteFolderById, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(FoldersMenu);
